import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Exclamation = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 14C12.6 14 13 13.6 13 13V7C13 6.4 12.6 6 12 6C11.4 6 11 6.4 11 7V13C11 13.6 11.4 14 12 14ZM12 15.5C11.3 15.5 10.8 16.1 10.8 16.7C10.8 17.3 11.3 18 12 18C12.7 18 13.2 17.4 13.2 16.8C13.2 16.2 12.7 15.5 12 15.5Z"
      fill="currentColor"
    />
  </svg>
)

export default Exclamation
